import {Mark} from 'tiptap';
import {markInputRule, updateMark, removeMark} from 'tiptap-commands';

/**
 * Color - Extends the built in Mark from tiptap allowing
 * the editor to set the color.
 */

export default class Color extends Mark {
  get name() {
    return 'color';
  }

  get schema() {
    return {
      attrs: {color: {default: ''}},
      parseDOM: [
        {
          style: 'color',
          getAttrs: (value) => {
            return {color: value};
          },
        },
      ],
      toDOM: (mark) => ['span', {style: `color: ${mark.attrs.color}`}, 0],
    };
  }

  commands({type}) {
    return (attrs) => {
      if (attrs.color) {
        return updateMark(type, attrs);
      }
      return removeMark(type);
    };
  }

  inputRules({type}) {
    return [markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type)];
  }
}
